import angular from 'angular';
import travelExpenseComponent from './travel-expense.component';

let travelExpenseModule = angular.module('travelExpense', [])
  .component('travelExpense', travelExpenseComponent);

export default travelExpenseModule;



// WEBPACK FOOTER //
// ./client/pages/expenses/travel-expense/travel-expense.js